export default {"src":"/_next/static/media/accessibility_new.2e75aec0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};